import { startTransition, useEffect, useState } from 'react';

import useSuspenseQuery from 'commons/useSuspenseQuery';
import useUserData from 'data-hooks/useUserData';
import { GET_FAVORITED_PRODUCT_IDS } from '@/graphql/queries';

const DEFAULT_RESPONSE = { data: { productIds: [] } };

const useFavoritedProductIds = (options = {}) => {
  const { isLoggedIn } = useUserData();

  // User state comes from localStorage, so the server never runs this query
  // and renders no favorites. Letting it fire during hydration would suspend
  // and mismatch the server HTML, so defer it to a post-mount transition
  // (the transition keeps the current UI instead of a Suspense fallback).
  const [canQuery, setCanQuery] = useState(false);
  useEffect(() => {
    startTransition(() => {
      setCanQuery(isLoggedIn);
    });
  }, [isLoggedIn]);

  const showFavorites = canQuery && isLoggedIn;

  // Separate suspense cache entry for the unskipped query. Without it, a
  // skipped render puts the shared entry in standby, and the next unskipped
  // render replaces the promise other components are suspended on, so they
  // never resume (CON-8862).
  const response = useSuspenseQuery(GET_FAVORITED_PRODUCT_IDS, {
    ...options,
    queryKey: ['favoritedProductIds'],
    skip: !showFavorites || options.skip,
  });

  return showFavorites ? response : DEFAULT_RESPONSE;
};

export default useFavoritedProductIds;
